const defaultState = {
  active: false,
  localized: false,
  currentWaypoint: null,
  nextWaypoint: null,
  contributionOpen: false,
  viewerPosition: null,
  completeDialogActive: false
};

//
// Action types
//

export const SET_CITY_WALK_ACTIVE = "SET_CITY_WALK_ACTIVE";
export const SET_CITY_WALK_LOCALIZED = "SET_CITY_WALK_LOCALIZED";
export const SET_CITY_WALK_WAYPOINTS_COUNT = "SET_CITY_WALK_WAYPOINTS_COUNT";
export const GO_TO_CITY_WALK_NEXT_WAYPOINT = "GO_TO_CITY_WALK_NEXT_WAYPOINT";
export const GO_TO_CITY_WALK_PREVIOUS_WAYPOINT = "GO_TO_CITY_WALK_PREVIOUS_WAYPOINT";
export const SET_CITY_WALK_CURRENT_WAYPOINT = "SET_CITY_WALK_CURRENT_WAYPOINT";
export const SET_CITY_WALK_NEXT_WAYPOINT = "SET_CITY_WALK_NEXT_WAYPOINT";
export const SET_CITY_WALK_CONTRIBUTION_OPEN = "SET_CITY_WALK_CONTRIBUTION_OPEN";
export const SET_CITY_WALK_VIEWER_POSITION = "SET_CITY_WALK_VIEWER_POSITION";
export const SET_CITY_WALK_COMPLETE_DIALOG_ACTIVE =
  "SET_CITY_WALK_COMPLETE_DIALOG_ACTIVE";

//
// Action creators
//

export function setCityWalkActive(mapKey, value) {
  return {
    type: SET_CITY_WALK_ACTIVE,
    mapKey,
    value
  };
}

export function setCityWalkLocalized(mapKey, value) {
  return {
    type: SET_CITY_WALK_LOCALIZED,
    mapKey,
    value
  };
}

export function setCityWalkWaypointsCount(mapKey, value) {
  return {
    type: SET_CITY_WALK_WAYPOINTS_COUNT,
    mapKey,
    value
  };
}

export function goToCityWalkNextWaypoint(mapKey) {
  return {
    type: GO_TO_CITY_WALK_NEXT_WAYPOINT,
    mapKey
  };
}

export function goToCityWalkPreviousWaypoint(mapKey) {
  return {
    type: GO_TO_CITY_WALK_PREVIOUS_WAYPOINT,
    mapKey
  };
}

export function setCityWalkCurrentWaypoint(mapKey, value) {
  return {
    type: SET_CITY_WALK_CURRENT_WAYPOINT,
    mapKey,
    value
  };
}
export function setCityWalkNextWaypoint(mapKey, value) {
  return {
    type: SET_CITY_WALK_NEXT_WAYPOINT,
    mapKey,
    value
  };
}

export function setCityWalkContributionOpen(mapKey, value) {
  return {
    type: SET_CITY_WALK_CONTRIBUTION_OPEN,
    mapKey,
    value
  };
}

export function setCityWalkViewerPosition(mapKey, value) {
  return {
    type: SET_CITY_WALK_VIEWER_POSITION,
    mapKey,
    value
  };
}

export function setCityWalkCompleteDialogActive(mapKey, value) {
  return {
    type: SET_CITY_WALK_COMPLETE_DIALOG_ACTIVE,
    mapKey,
    value
  };
}

function setCityWalkActiveHandler(state, value) {
  return { ...state, isActive: value };
}

function setCityWalkLocalizedHandler(state, value) {
  return { ...state, localized: value };
}

function setCityWalkCurrentWaypointHandler(state, value) {
  return { ...state, currentWaypoint: value };
}

function setCityWalkWaypointsCountHandler(state, value) {
  return { ...state, waypointsCount: value };
}

function goToCityWalkNextWaypointHandler(state) {
  const { currentWaypoint } = state;
  const nextWaypoint = currentWaypoint + 1;
  const targetWaypoint =
    nextWaypoint < state.waypointsCount ? nextWaypoint : state.currentWaypoint;

  return { ...state, currentWaypoint: targetWaypoint };
}
function goToCityWalkPreviousWaypointHandler(state) {
  const { currentWaypoint } = state;
  const previousWaypoint = currentWaypoint - 1;
  const targetWaypoint = previousWaypoint >= 0 ? previousWaypoint : currentWaypoint;

  return { ...state, currentWaypoint: targetWaypoint };
}

function setCityWalkNextWaypointHandler(state, value) {
  return { ...state, nextWaypoint: value };
}

function setCityWalkContributionOpenHandler(state, value) {
  return { ...state, contributionOpen: value };
}

function setCityWalkViewerPositionHandler(state, value) {
  return { ...state, viewerPosition: value };
}

function setCityWalkCompleteDialogActiveHandler(state, value) {
  return { ...state, completeDialogActive: value };
}

//
// Reducer and handlers
//

export default function reduceCityWalk(state, action) {
  switch (action && action.type) {
    case SET_CITY_WALK_ACTIVE:
      return setCityWalkActiveHandler(state, action.value);

    case SET_CITY_WALK_LOCALIZED:
      return setCityWalkLocalizedHandler(state, action.value);

    case SET_CITY_WALK_CURRENT_WAYPOINT:
      return setCityWalkCurrentWaypointHandler(state, action.value);

    case SET_CITY_WALK_WAYPOINTS_COUNT:
      return setCityWalkWaypointsCountHandler(state, action.value);

    case GO_TO_CITY_WALK_NEXT_WAYPOINT:
      return goToCityWalkNextWaypointHandler(state);

    case GO_TO_CITY_WALK_PREVIOUS_WAYPOINT:
      return goToCityWalkPreviousWaypointHandler(state);

    case SET_CITY_WALK_NEXT_WAYPOINT:
      return setCityWalkNextWaypointHandler(state, action.value);

    case SET_CITY_WALK_CONTRIBUTION_OPEN:
      return setCityWalkContributionOpenHandler(state, action.value);

    case SET_CITY_WALK_VIEWER_POSITION:
      return setCityWalkViewerPositionHandler(state, action.value);

    case SET_CITY_WALK_COMPLETE_DIALOG_ACTIVE:
      return setCityWalkCompleteDialogActiveHandler(state, action.value);

    default:
      return state || defaultState;
  }
}
